import { fetchApi } from "./fetchApi";
import store from "../store";

export default {
  batchEditTestPlan({ serviceAreaId, data }) {
    return fetchApi({
      data: { payloadList: data },
      method: "post",
      url: `/api/testPlan/${serviceAreaId}/batch`,
    });
  },

  batchEditReleaseNote({ data }) {
    return fetchApi({
      data: { payloadList: data },
      method: "post",
      url: `/api/releaseNote/batch`,
    });
  },
  async get(id) {
    const result = await fetchApi({
      method: "get",
      url: `/api/releaseNote/${id}`,
    });

    return result;
  },
  getTestPlan(id, sa) {
    return fetchApi({
      method: "get",
      url: `/api/releaseNote/${id}/testPlan/${sa}`,
    });
  },
  getTestPlanList(packId) {
    const serviceAreaId = store.state.session.serviceArea;

    const data = {
      operator: "AND",
      list: [
        {
          comparator: "=",
          term: "packId",
          value: packId,
        },
        {
          comparator: "=",
          term: "serviceAreaId",
          value: serviceAreaId,
        },
      ],
    };
    return fetchApi({
      data,
      method: "post",
      url: "/api/testPlan/search",
    });
  },
  async list(id) {
    //This uses the releaseNoteService.search() route
    const result = await fetchApi({
      method: "get",
      url: `/api/pack/${id}/releaseNotes`,
    });

    return result;
  },
  async packDashboardWidgetSearch(data) {
    data.offset = 0;
    data.rowCount = 9999;
    data.sortBy = ["releaseNote.id"];
    data.sortDesc = [];

    const packFilter = {
      attributeName: "packId",
      dataType: "pack",
      operator: "in",
      value: [data.packId],
      valueType: "array",
      attributeNameLabel: "Packs",
      operatorLabel: "=",
    };

    data.filterList.push(packFilter);

    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/search",
    });

    return response.data.result;
  },
  async unpublishedReleaseNoteSearch() {
    const data = {};
    data.filterList = [];
    data.offset = 0;
    data.rowCount = 9999;
    data.sortBy = ["releaseNote.id"];
    data.sortDesc = [];

    const documentationStatusFilter = {
      attributeName: "documentationStatus",
      attributeNameLabel: "Documentation Status",
      dataType: "string",
      operator: "notIn",
      operatorLabel: "!=",
      value: ["Cancelled", "Pulled", "Published"],
      valueLabel: "Corrections Needed",
      valueType: "array",
    };
    data.filterList.push(documentationStatusFilter);

    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/search",
    });

    return response.data.result;
  },
  async missingUatJiraSearch() {
    const data = {};
    data.filterList = [];
    data.offset = 0;
    data.rowCount = 9999;
    data.sortBy = ["releaseNote.id"];
    data.sortDesc = [];

    const packStatusFilter = {
      attributeName: "pack.status",
      attributeNameLabel: "Pack Status",
      dataType: "string",
      operator: "notIn",
      operatorLabel: "!=",
      value: ["In Process"],
      valueLabel: "In Process",
      valueType: "array",
    };

    data.filterList.push(packStatusFilter);

    const documentationStatusFilter = {
      attributeName: "documentationStatus",
      attributeNameLabel: "Documentation Status",
      dataType: "string",
      operator: "in",
      operatorLabel: "=",
      value: ["Published"],
      valueLabel: "Published",
      valueType: "array",
    };

    data.filterList.push(documentationStatusFilter);

    const uatJiraFilter = {
      attributeName: "uatJira",
      attributeNameLabel: "UAT Jira",
      dataType: "string",
      operator: "in",
      operatorLabel: "=",
      value: [null],
      valueLabel: "UAT Jira",
      valueType: "array",
    };

    data.filterList.push(uatJiraFilter);

    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/search",
    });

    return response.data.result;
  },
  post(releaseNote) {
    return fetchApi({
      data: releaseNote,
      method: "post",
      url: "/api/releaseNote",
    });
  },
  put(releaseNote) {
    const releaseNoteId = releaseNote.id;
    const tempReleaseNote = Object.assign({}, releaseNote);

    //Removing fields that are not edited by the ReleaseNoteForm
    delete tempReleaseNote.createdBy;
    delete tempReleaseNote.dateCreated;
    delete tempReleaseNote.id;
    delete tempReleaseNote.individualSetup;
    // Remove computed display name fields (these are generated by SQL JOINs, not stored columns)
    delete tempReleaseNote.buildAnalystDisplayName;
    delete tempReleaseNote.qaAnalystDisplayName;
    delete tempReleaseNote.sourceTemplatePackId;
    delete tempReleaseNote.sourceTemplateTitle;

    return fetchApi({
      data: tempReleaseNote,
      method: "put",
      url: `/api/releaseNote/${releaseNoteId}`,
    });
  },
  putIndividualSetup(releaseNoteId, individualSetupData) {
    const individualSetup = { individualSetup: individualSetupData };
    return fetchApi({
      data: individualSetup,
      method: "put",
      url: `/api/releaseNote/${releaseNoteId}`,
    });
  },
  putTestPlan(testPlan) {
    const { releaseNoteId, serviceArea } = testPlan;
    const tempTestPlan = Object.assign({}, testPlan);
    delete tempTestPlan.releaseNoteId;
    delete tempTestPlan.serviceArea;
    // Remove computed display name fields (generated by SQL JOINs, not stored columns)
    delete tempTestPlan.assignedToDisplayName;

    return fetchApi({
      data: tempTestPlan,
      method: "put",
      url: `/api/releaseNote/${releaseNoteId}/testPlan/${serviceArea}`,
    });
  },

  async copyFromTemplate(id, { packId, qaJira }) {
    const response = await fetchApi({
      data: { packId, qaJira },
      method: "post",
      url: `/api/releaseNote/${id}/copy`,
    });

    return response.data.result;
  },
  async getRelatedReleaseNotes(qaJira) {
    const response = await fetchApi({
      method: "get",
      url: `/api/releaseNote/jira/${encodeURIComponent(qaJira)}/relatedReleaseNotes`,
    });

    return response.data.result;
  },

  async deleteRecord(id) {
    return fetchApi({
      method: "delete",
      url: `/api/releaseNote/${id}`,
    });
  },
  async search(data) {
    const response = await fetchApi({
      data,
      method: "post",
      url: "/api/releaseNote/search",
    });

    return response.data.result;
  },
};
